import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import store from '../../../../store';
import type { ConstraintFieldNames } from './columns';

const fields: ConstraintFieldNames[] = ['chargesMapFees', 'requiresNda', 'requiresLetterhead'];

export default function Constraints() {
  const { formState, agencies } = useSnapshot(store);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const additionalRequirements = useMemo<boolean>(() => {
    let value = false;

    const ids = new Set([...Array.from(formState.mapsSelection), ...Array.from(formState.asbuiltsSelection)]);

    ids.forEach((id) => {
      const a = agencies[id];
      if (a) {
        fields.forEach((f) => {
          if (a[f]) {
            value = true;
          }
        });
      }
    });

    return value;
  }, [agencies, formState.asbuiltsSelection.size, formState.mapsSelection.size]);

  if (!additionalRequirements) return null;

  return (
    <div className="mb-2 mt-4 flex w-full flex-col space-y-2">
      <div>
        ⚠️ Heads up - selected agencies have additional constraints. We'll collect the necessary documentation in the
        next step.
      </div>
    </div>
  );
}
